import { ExposeAppCard } from '@orcha/micro-library-core-ui';
import useAppData from 'src/hooks/useAppData';
import { ClientSideDataWrapperProps } from './ClientSideDataWrapper.types';
import AppCardWrapper from '../AppCardWrapper';

export const ClientSideDataWrapper = ({
  appId,
  hideImages,
}: ClientSideDataWrapperProps) => {
  const { appData, isLoading } = useAppData(appId);
  if (isLoading) {
    return <ExposeAppCard isLoading data-testid="app-card-loading" />;
  }

  return appData ? (
    <AppCardWrapper
      hideImages={hideImages}
      appData={appData}
      AppCardComponent={ExposeAppCard}
    />
  ) : (
    <></>
  );
};
